import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';
import useSessionContext from 'src/hooks/useSessionContext';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress
} from '@mui/material';

import { useLocalStorage } from 'src/hooks/useLocalStorage';
import withErrorBoundary from 'src/hocs/withErrorBoundary';
import { gtagEvent } from 'src/utils/gtag';
import Logo from 'src/components/Logo';
import Page from 'src/components/Page';

import useStyles from './styles';

const ConsumeView = (props) => {
  const { redirectTo } = props;
  const { authState } = useOktaAuth();
  const { session, loadSession } = useSessionContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const { value: redirectUrl } = useLocalStorage(
    'bootstrapper-redirect-url',
    null
  );

  useEffect(() => {
    gtagEvent('login', { method: 'Okta' });
  }, []);

  useEffect(() => {
    (async () => {
      if (authState.isPending) return;
      if (authState.isAuthenticated) {
        try {
          await loadSession(true);
        } catch (error) {
          navigate('/sso?error=true', {
            replace: true
          });
        }
      }
      if (!authState.isPending && !authState.isAuthenticated) {
        navigate('/sso?logout=true', {
          replace: true
        });
      }
    })();
  }, [authState.isPending, authState.isAuthenticated]);

  useEffect(() => {
    if (session) {
      navigate(redirectUrl || redirectTo, { replace: true });
    }
  }, [session]);

  return (
    <Page className={classes.root} title="Signed with Zendesk">
      <Box display="flex" flexDirection="column" height="100%">
        <Container maxWidth="sm">
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            padding="20px"
            marginBottom="20px"
          >
            <Logo width={70} />
          </Box>
          <Card className={classes.ssocard}>
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="center"
                padding="20px"
              >
                <CircularProgress className={classes.circularProgress} />
              </Box>
              <Typography align="center" variant="h3" gutterBottom>
                Signed in with <strong>Zendesk</strong>
              </Typography>
              <Typography align="center" variant="body2" gutterBottom>
                You&apos;re now authenticated to access the{' '}
                <strong>Bootstrapper</strong>.
              </Typography>
              <Button
                sx={{ mt: 3 }}
                fullWidth
                disabled
                variant="contained"
                color="primary"
                disableElevation
                size="large"
              >
                Redirecting...
              </Button>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </Page>
  );
};

ConsumeView.propTypes = {
  redirectTo: PropTypes.string.isRequired
};

export default withErrorBoundary(ConsumeView);
